import { ReservationArgs } from '~/lib/data-contract';
import { postRequest } from '~/shared/utils';

export async function addReservation(apiUrl: string, args: ReservationArgs) {
    const request = postRequest(apiUrl, args);

    return request();
}
